import React from 'react';
import logo from '../../images/logo.svg';

const Header = () => (
	<header>
		<h1><a href="/"><img className="logo" src={logo} alt="CabinTime" /></a></h1>
	</header>
);

export default Header;